"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LIST_ITEM_INDENT_WIDTH = void 0;
const LIST_ITEM_INDENT_WIDTH = 15;
exports.LIST_ITEM_INDENT_WIDTH = LIST_ITEM_INDENT_WIDTH;
//# sourceMappingURL=constants.js.map